import React, { useEffect } from "react";
import { Box, Typography, Paper, Skeleton, Icon } from "@mui/material";
import { DashboardStats } from "../components/DashboardStats/DashboardStats";
import { SystemHealth } from "../components/SystemHealth/SystemHealth";
import { useSuperAdminContext } from "../providers/SuperAdminProvider";

export const SuperAdminDashboard: React.FC = () => {
  const { isLoading, systemStats, fetchSystemStats } = useSuperAdminContext();

  useEffect(() => {
    fetchSystemStats();
  }, [fetchSystemStats]);

  const emptyStats = {
    totalClients: 0,
    activeClients: 0,
    totalRevenue: 0,
    newClientsThisMonth: 0,
    systemHealth: {
      cpu: 0,
      memory: 0,
      storage: 0,
    },
    recentTransactions: [],
    // Add other required properties with default values
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Dashboard Overview
      </Typography>

      <Box sx={{ mb: 4 }}>
        {isLoading ? (
          <Box sx={{ display: "flex", gap: 2 }}>
            {[1, 2, 3, 4].map((i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                width="25%"
                height={120}
                sx={{ borderRadius: 2 }}
              />
            ))}
          </Box>
        ) : (
          <DashboardStats
            stats={systemStats || emptyStats}
            isLoading={isLoading}
          />
        )}
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          System Health
        </Typography>
        {isLoading ? (
          <Skeleton
            variant="rectangular"
            height={200}
            sx={{ borderRadius: 2 }}
          />
        ) : (
          <SystemHealth
            cpu={systemStats?.systemHealth?.cpu || 0}
            memory={systemStats?.systemHealth?.memory || 0}
            storage={systemStats?.systemHealth?.storage || 0}
          />
        )}
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          Recent Activity
        </Typography>
        {isLoading ? (
          <Skeleton
            variant="rectangular"
            height={300}
            sx={{ borderRadius: 2 }}
          />
        ) : (
          <Paper
            sx={{
              p: 3,
              borderRadius: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: 300,
              bgcolor: "background.paper",
            }}
          >
            <Box
              sx={{
                width: 120,
                height: 120,
                borderRadius: "50%",
                bgcolor: "grey.100",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
              }}
            >
              <Icon sx={{ fontSize: 48, color: "grey.400" }}>timeline</Icon>
            </Box>
            <Typography variant="h6" color="text.secondary" gutterBottom>
              No Activity Yet
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center">
              Activity data will appear here once your system starts processing
              transactions.
            </Typography>
          </Paper>
        )}
      </Box>
    </Box>
  );
};
